import * as StoreUtil from '../util/InClientStoreUtil';
import InstallAppRequest from 'owa-service/lib/contract/InstallAppRequest';
import InstallExtensionJsonRequest from 'owa-service/lib/contract/InstallExtensionJsonRequest';
import installExtensionJsonRequestFactory from 'owa-service/lib/factory/installExtensionJsonRequest';
import InstallExtensionJsonResponse from 'owa-service/lib/contract/InstallExtensionJsonResponse';
import installExtensionOperation from 'owa-service/lib/operation/installExtensionOperation';
import { createOverrideOptions } from '../util/InClientStoreHelper';
import { getClientVersion } from 'owa-session-store';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';
import ServiceEndpoint = OSF.ServiceEndpoint;

export function registerMethod(serviceEndPoint: ServiceEndpoint) {
    serviceEndPoint.registerMethod(
        'InstallOutlookWebExtByProductId',
        (data: any, responseMethod: Function) => {
            InstallOutlookWebExtByProductId(data).then(response => {
                if (response.Body.ResponseClass.toString() == 'Error') {
                    responseMethod(
                        [
                            response.Body.MessageText.toString(),
                            response.Body.ResponseCode.toString(),
                        ],
                        -1
                    );
                } else {
                    const ProductId = data;
                    const wasFirstInstall = false;
                    responseMethod([ProductId, wasFirstInstall], 0);
                }
                StoreUtil.updateAddinSurface();
            });
        },
        Microsoft.Office.Common.InvokeType.async,
        false /* isBlocking */
    );
}

function InstallOutlookWebExtByProductId(data: string): Promise<InstallExtensionJsonResponse> {
    const Body: InstallAppRequest = {
        __type: 'InstallAppRequest:#Exchange',
        MarketplaceAssetId: null,
        MarketplaceContentMarket: null,
        Client: 'WAC_Outlook',
        ClientVersion: getClientVersion(),
        SendWelcomeEmail: true,
        ManifestUrl: null,
        Manifest: null,
        Id: data,
    };
    const installRequest: InstallExtensionJsonRequest = {
        Header: getJsonRequestHeader(StoreUtil.getUserTimeZone()),
        Body: Body,
    };

    const params: InstallExtensionJsonRequest = installExtensionJsonRequestFactory(installRequest);
    const fetchOptions = createOverrideOptions();

    return installExtensionOperation(params, fetchOptions);
}
